import React, {Component} from "react"

export default class DetailInfoRow extends Component {
  render() {
    if (!this.props.children) {
      return (
        <div className="sh-detail-info-row sh-detail-info-row--value">
          <div className="label">{this.props.label}</div>
          <div className="value">{this.props.value || "n/a"}</div>
        </div>
      )
    } else {
      return (
        <div className="sh-detail-info-row sh-detail-info-row--list">
          <div className="label">{this.props.label}</div>
          <div className="list">{this.props.children}</div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/decorators/DetailInfoRow.js